<template>
  <div
    class="lume-tooltip__title"
    data-j-tooltip__title
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use '../../styles';
</style>
